"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stark_app_1 = require("@ice/stark-app");
var stark_data_1 = require("@ice/stark-data");
// 整体通过主子应用的通信来完成设备弹窗的唤起
var showManage = function (type) {
    return function () {
        if (stark_app_1.isInIcestark()) {
            // 我这里只兼容了icestrack
            stark_data_1.event.emit("subAppsMsg", {
                type: "deviceConnect",
                data: type,
            });
        }
    };
};
var showPadManage = showManage("pad");
exports.showPadManage = showPadManage;
var showIcardManage = showManage("icard");
exports.showIcardManage = showIcardManage;
var showGpyManage = showManage("gpy");
exports.showGpyManage = showGpyManage;
